var TAstaffcard = (function($) {
    'use strict';

    var cards = [];
    var isAnimating = false;
    var observer = null;
    const STAGGER_DELAY = 0.15; // Faster stagger between cards
    const ANIMATION_DURATION = 0.45; // Slightly quicker animation
    const VIEWPORT_THRESHOLD = 0.4; // 40% of viewport height
    const BUFFER_TIME = 0.1; // Extra buffer time
    const TOTAL_ANIMATION_TIME = ANIMATION_DURATION + (STAGGER_DELAY * 1.5) + BUFFER_TIME; // Total time including stagger and buffer

    function init() {
        // Wait for GSAP to be ready
        if (typeof gsap === 'undefined') {
            setTimeout(init, 50);
            return;
        }

        cards = document.querySelectorAll('.staff-card');
        if (!cards.length) return;

        // Register plugin for better transform handling
        gsap.registerPlugin(CSSPlugin);
        
        // Force GPU acceleration for smoother animations
        gsap.set(cards, { 
            opacity: 0,
            scale: 0.85, // Slightly larger start scale
            y: 20, // Smaller initial offset
            force3D: true,
            transformPerspective: 1000
        });

        // Check if we're in query mode by looking for the filter
        const isQueryMode = document.getElementById('position-filter') !== null;
        
        if (isQueryMode) {
            // Deal animation on page load for query mode
            dealCards();
        } else {
            // Set up intersection observer for scroll animation
            setupScrollAnimation();
        }
        
        events();
    }

    function setupScrollAnimation() {
        observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const section = entry.target;
                    const sectionCards = section.querySelectorAll('.staff-card');
                    if (sectionCards.length) {
                        dealCards(sectionCards);
                        // Only animate once
                        observer.unobserve(section);
                    }
                }
            });
        }, {
            threshold: VIEWPORT_THRESHOLD,
            rootMargin: '50px 0px' // Start animation slightly before reaching threshold
        });

        // Observe the staff card section
        const sections = document.querySelectorAll('.sec--staff-card');
        sections.forEach(section => observer.observe(section));
    }

    function events() {
        // Handle filter change
        const filter = document.getElementById('position-filter');
        if (filter) {
            filter.addEventListener('change', function(e) {
                e.preventDefault();
                if (!isAnimating) {
                    const targetUrl = this.value;
                    
                    // Start the stack animation and chain the navigation
                    stackCards().then(function() {
                        // Add buffer time to ensure animation completes
                        setTimeout(function() {
                            window.location.href = targetUrl;
                        }, TOTAL_ANIMATION_TIME * 1000);
                    });
                }
                return false;
            });
        }
    }

    function stackCards() {
        if (!cards.length) return Promise.resolve();
        
        isAnimating = true;
        
        return gsap.to(cards, {
            duration: ANIMATION_DURATION,
            opacity: 0,
            scale: 0.85,
            y: -40, // Smaller offset for quicker feel
            stagger: {
                amount: STAGGER_DELAY,
                from: "end"
            },
            ease: "back.in(1.4)", // Slightly stronger easing
            force3D: true
        });
    }

    function dealCards(targetCards = cards) {
        if (!targetCards.length) return;
        
        isAnimating = true;

        gsap.to(targetCards, {
            duration: ANIMATION_DURATION,
            opacity: 1,
            scale: 1,
            y: 0,
            stagger: {
                amount: STAGGER_DELAY,
                from: "start"
            },
            ease: "back.out(1.4)", // Slightly stronger easing
            force3D: true,
            onComplete: () => {
                isAnimating = false;
            }
        });
    }

    return {
        init: init
    };
}(jQuery));